import { styled } from "react-alicerce-components";

export const Container = styled.div`
    .container-page-footer {
        z-index: 4;
    }
`